/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

import * as filters from "./filters";
import "./utils/fetch-interceptor.js";

Vue.config.productionTip = false;

for (const key in filters) {
  Vue.filter(key, filters[key]);
}

/* new Vue({
  vuetify: vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
*/

// Versione asincrona con chiamata a funzione vuetify per gestione traduzioni !!!
const init = async function() {
  const configResponse = await fetch("/config.json");
  const config = await configResponse.json();
  window.appConfig = config;

  return new Vue({
    vuetify: await vuetify(),
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
};
init();
// router.replace('/login')
